<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <el-button
          v-if="backRole('PM_1')"
          type="primary"
          @click="startCreate()"
          size="mini"
          >项目申请</el-button
        >
      </div>
      <label class="label-name">所属公司：</label>
      <el-select
        size="small"
        :disabled="noSelectOrganization"
        class="organization-select"
        v-model="form.depId"
        placeholder="请选择所属公司"
      >
        <el-option
          v-for="item in organizationListData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="list-title" style="padding: 5px 10px 8px; background: #f8f8f8">
      <section style="font-size: 12px">
        <div class="filter-item" style="margin-bottom: 5px">
          <a
            :href="
              baseURL +
              '/gc/project/early/report/export?depId=' +
              (form.depId == 0 ? '' : form.depId)
            "
            style="float: right; position: relative; z-index: 2"
            target="_blank"
          >
            <el-button size="mini" type="primary"
              >项目进度情况表格下载</el-button
            >
          </a>

          <!-- 筛选内容 -->
          <label>项目组：</label>
          <el-select size="mini" v-model="teamId" placeholder="请选择">
            <el-option
              v-for="item in teamArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <label class="label-name ml5px">项目编号：</label>
          <span style="width: 210px; display: inline-block">
            <el-input
              size="mini"
              type="number"
              v-model="form.number"
            ></el-input>
          </span>

          <label class="label-name ml5px">项目负责人：</label>
          <span style="width: 160px; display: inline-block">
            <el-input size="mini" type="" v-model="form.leader"></el-input>
          </span>
        </div>
        <div class="filter-item" style="margin-bottom: 5px">
          <label class="label-name">项目名称：</label>
          <span style="width: 420px; display: inline-block">
            <el-input size="mini" type="" v-model="form.name"></el-input>
          </span>

          <el-button
            type="success"
            @click="getFilterData()"
            style="margin-left: 5px"
            size="mini"
            >搜索筛选结果</el-button
          >
          <el-button
            type="primary"
            @click="resetFilterData()"
            style="margin-left: 5px"
            size="mini"
            >重置</el-button
          >
        </div>
      </section>
    </div>

    <el-table
      class="statistics-table"
      :data="paginationData"
      style="width: 100%"
      :height="tableHeight"
      v-loading="loading"
    >
      <el-table-column label="项目编号/名称" fixed width="280px">
        <template slot-scope="scope">
          <router-link
            target="_blank"
            class="table-link"
            :to="'/Project/Detail/' + scope.row.id"
          >
            {{ scope.row.number + " - " + scope.row.name }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="deptName"
        v-if="form.depId === 0"
        label="所属公司"
        width="180px"
      >
      </el-table-column>
      <el-table-column
        prop="customer"
        v-if="form.depId === 0"
        label="施工单位"
        width="180px"
      >
      </el-table-column>
      <el-table-column label="中介单位">
        <el-table-column prop="sjdw" label="设计单位" width="200px">
        </el-table-column>
        <el-table-column prop="kcdw" label="勘测单位" width="200px">
        </el-table-column>
        <el-table-column prop="jldw" label="监理单位" width="200px">
        </el-table-column>
      </el-table-column>
      <el-table-column label="工程造价(元)">
        <el-table-column prop="xmgs" label="估算" width="80px">
        </el-table-column>
        <el-table-column prop="ztz" label="概算" width="80px">
        </el-table-column>
      </el-table-column>
      <el-table-column label="项目形象进度">
        <el-table-column label="完成百分比" width="120px">
          <template slot-scope="scope">
            {{ scope.row.rate ? scope.row.rate + "%" : "" }}
          </template>
        </el-table-column>
        <el-table-column label="完成投资额" width="120px">
          <template slot-scope="scope">
            {{ scope.row.wctze ? scope.row.wctze + "元" : "" }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="阶段性工作节点时间">
        <el-table-column label="项目需求">
          <el-table-column label="上报时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.xqUptime != -1
                  ? scope.row.xqUptime != -2
                    ? scope.row.xqUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="批复时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.xqDowntime != -1
                  ? scope.row.xqDowntime != -2
                    ? scope.row.xqDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="勘测设计">
          <el-table-column label="计划完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.kcUptime != -1
                  ? scope.row.kcUptime != -2
                    ? scope.row.kcUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="实际完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.kcDowntime != -1
                  ? scope.row.kcDowntime != -2
                    ? scope.row.kcDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="概算内审">
          <el-table-column label="上报时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.gsnsUptime != -1
                  ? scope.row.gsnsUptime != -2
                    ? scope.row.gsnsUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="完成时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.gsnsDowntime != -1
                  ? scope.row.gsnsDowntime != -2
                    ? scope.row.gsnsDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="发改概算审核">
          <el-table-column label="上报时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.bfgUptime != -1
                  ? scope.row.bfgUptime != -2
                    ? scope.row.bfgUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="完成时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.bfgDowntime != -1
                  ? scope.row.bfgDowntime != -2
                    ? scope.row.bfgDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="项目立项">
          <el-table-column label="计划完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.lxUptime != -1
                  ? scope.row.lxUptime != -2
                    ? scope.row.lxUptime
                    : "无"
                  : "立项后补"
              }}
            </template>
          </el-table-column>
          <el-table-column label="批复时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.lxDowntime != -1
                  ? scope.row.lxDowntime != -2
                    ? scope.row.lxDowntime
                    : "无"
                  : "立项后补"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="招标控制价内审">
          <el-table-column label="上报时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.yskzjUptime != -1
                  ? scope.row.yskzjUptime != -2
                    ? scope.row.yskzjUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="完成时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.yskzjDowntime != -1
                  ? scope.row.yskzjDowntime != -2
                    ? scope.row.yskzjDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="发改招标控制价审核">
          <el-table-column label="上报时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.fgysUptime != -1
                  ? scope.row.fgysUptime != -2
                    ? scope.row.fgysUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="完成时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.fgysDowntime != -1
                  ? scope.row.fgysDowntime != -2
                    ? scope.row.fgysDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="材料及设备采购需求">
          <el-table-column label="上报时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.clcgxqUptime != -1
                  ? scope.row.clcgxqUptime != -2
                    ? scope.row.clcgxqUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="批复时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.clcgxqDowntime != -1
                  ? scope.row.clcgxqDowntime != -2
                    ? scope.row.clcgxqDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="材料及设备采购">
          <el-table-column label="上报时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.clcgUptime != -1
                  ? scope.row.clcgUptime != -2
                    ? scope.row.clcgUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="批复时间" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.clcgDowntime != -1
                  ? scope.row.clcgDowntime != -2
                    ? scope.row.clcgDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="项目招标">
          <el-table-column label="计划完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.sgzbwcsj != -1
                  ? scope.row.sgzbwcsj != -2
                    ? scope.row.sgzbwcsj
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="实际完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.xmzbDowntime != -1
                  ? scope.row.xmzbDowntime != -2
                    ? scope.row.xmzbDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="监理招标">
          <el-table-column label="计划完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.jlzbUptime != -1
                  ? scope.row.jlzbUptime != -2
                    ? scope.row.jlzbUptime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column label="实际完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.jlzbDowntime != -1
                  ? scope.row.jlzbDowntime != -2
                    ? scope.row.jlzbDowntime
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="项目开工">
          <el-table-column label="计划完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.jhkgsj != -1
                  ? scope.row.jhkgsj != -2
                    ? scope.row.jhkgsj
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="kgsj" label="实际开工" width="90px">
          </el-table-column>
        </el-table-column>
        <el-table-column label="项目验收">
          <el-table-column label="计划完成" width="90px">
            <template slot-scope="scope">
              {{
                scope.row.jhwgsj != -1
                  ? scope.row.jhwgsj != -2
                    ? scope.row.jhwgsj
                    : "无"
                  : "已完成"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="yssj" label="实际完成" width="90px">
          </el-table-column>
        </el-table-column>
        <el-table-column prop="earlyRemark" label="备注" width="250px">
        </el-table-column>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-left: -5px"
      v-if="form.pageTotal > form.pageSize"
      class="list-pagination"
      background
      :page-size="form.pageSize"
      :pager-count="9"
      :current-page="form.page + 1"
      layout="pager"
      :total="form.pageTotal"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<style lang="scss">
.component-content .statistics-table {
  border: 1px #888 solid;
  color: #000;

  a {
    color: #000;
  }

  thead.is-group th {
    background: #999;
    color: #fff;
    font-size: 14px;
  }

  td,
  th,
  th.is-leaf {
    border-bottom: 1px #888 solid;
    border-right: 1px #888 solid;
  }
}
</style>
<script>
import { mapState } from "vuex";

import Role from "@/Mixins/role";
export default {
  components: {},
  mixins: [Role],
  computed: {
    ...mapState({
      organization: (state) => state.main.organization,
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      baseURL: axios.defaults.baseURL,

      organizationListData: [],
      noSelectOrganization: true,
      // depId: "",

      // 列表
      loading: true,
      pageSize: 30,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],

      form: {
        page: 0,
        pageSize: 30,
        depId: "",
        leader: "",
        name: "",
        number: "",
        teamId: "",
      },

      // 筛选搜索
      teamId: 0,
      filterKey: "",
      teamArr: [],

      tableHeight: 1000,
    };
  },
  created() {
    console.log(document.documentElement.clientHeight);
    this.tableHeight = document.documentElement.clientHeight - 275;
  },
  mounted() {
    this.organizationListData.push({
      id: 0,
      name: "集团所有公司",
      depId: 0,
    });
    let _or =
      this.organization.length > 0 ? this.organization[0].childDepts : [];
    this.organizationListData = this.organizationListData.concat(_or);

    this.form.depId = this.userData.secDepIds.split(",")[0] / 1;

    if (this.form.depId == "7") {
      this.noSelectOrganization = false;
      this.form.depId = 0;
    }
    // 获取列表
    // this.getLists()
    // 获取项目组
    this.getTeam();
  },
  methods: {
    // 获取项目组
    getTeam() {
      ajax.post("/gc/project/team/list", "", (res) => {
        this.teamArr = [
          {
            id: 0,
            name: "全部",
          },
        ];
        this.teamArr = this.teamArr.concat(res.vo.array);
      });
    },
    projectDetail(row) {
      this.$router.push("/Project/Detail/" + row.id);
    },
    projectDelete(row) {
      ajax.post("/gc/project/del/" + row.id, "", (res) => {
        this.$message.error("删除项目成功");
        // 重新获取列表
        this.getLists();
      });
    },
    startCreate() {
      this.$router.push("/Project/Create");
    },
    // 当前页
    handleCurrentChange(val) {
      this.form.page = val - 1;
      this.getLists();
    },

    // 重置
    resetFilterData() {
      this.form.leader = "";
      this.form.name = "";
      this.form.number = "";
      this.form.teamId = "";
      this.form.page = 0;
      this.teamId = 0;

      // 获取符合条件的列表
      this.getLists();
    },
    // 搜索筛选新闻数据
    getFilterData() {
      this.form.page = 0;
      // this.form.status = this.filterStatus == "全部" ? "" : this.filterStatus;
      this.form.teamId = this.teamId == "0" ? "" : this.teamId;

      this.getLists();
    },
    // 分页筛选数据
    getPaginationData() {
      // 分页筛选
      this.paginationData = this.filterData;
    },
    // 获取列表
    getLists() {
      ajax.get("/gc/project/early/info/list", this.form, (res) => {
        this.loading = false;
        this.filterData = this.listData = res.vo.list;
        this.form.pageTotal = res.vo.size;
        this.getPaginationData();
      });
    },
  },
  watch: {
    "form.depId"() {
      this.getLists();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/statisticslist.vue